import { Button } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useTranslation from '../../localization/useTranslation';
import { shell } from '../../theme/palette';

const STORAGE_KEY = 'dentrist-cookie-consent';

/**
 * Fixed bottom cookie consent banner. Persists acceptance in localStorage.
 */
const CookieConsent = () => {
  const { t } = useTranslation();
  const { language } = useSelector((state) => state.language);
  const { theme } = useSelector((state) => state.theme);
  const [visible, setVisible] = useState(false);
  const isRtl = language === 'ar';
  const colors = theme === 'dark' ? shell.dark : shell.light;

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored !== 'accepted') {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      // Ignore storage failures; still dismiss for this session.
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t('cookies.title')}
      style={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 1100,
        direction: isRtl ? 'rtl' : 'ltr',
      }}
    >
      <div
        style={{
          margin: '0 auto',
          maxWidth: 720,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 16,
          padding: '14px 18px',
          borderRadius: 12,
          border: `1px solid ${colors.border}`,
          backgroundColor: colors.chromeBg,
          color: colors.text,
          boxShadow: '0 12px 32px rgba(0, 0, 0, 0.18)',
        }}
      >
        <div style={{ flex: '1 1 220px', minWidth: 0 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('cookies.title')}</div>
          <div style={{ fontSize: 13, opacity: 0.85, lineHeight: 1.5 }}>
            {t('cookies.message')}
          </div>
        </div>
        <Button
          type="primary"
          onClick={accept}
          style={{ backgroundColor: '#1fbac2', borderColor: '#1fbac2' }}
        >
          {t('cookies.accept')}
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
